<template>
  <div ref="XterminateGame" class="transparent xterminate-game">
    <h2>{{ $t("portfolio.xterminate.play.title") }}</h2>
    <hr class="secondary" />
    <p v-html="$t('portfolio.xterminate.play.paragraph', { purple: 'text-white-purple' })" />
    <img
      :alt="$t('portfolio.xterminate.play.altLabel')"
      src="/img/3DTextures/xterminate/instructions/gates.jpg"
      class="xterminate-game-image scenario black"
    />
    <p>
      <span class="text-white-purple">
        <small>{{ $t("portfolio.xterminate.play.note") }}</small>
      </span>
    </p>
    <div class="text-center">
      <button
        v-on:click="setGameModalStatus(true)"
        :disabled="modalOpen"
        class="general-cta primary"
        type="button"
      >
        {{ $t("portfolio.xterminate.play.buttonLabel") }}
      </button>
    </div>
    <xterminate-instance v-if="modalOpen" @closeGame="setGameModalStatus(false)" />
  </div>
</template>

<script>
const XterminateInstance = () =>
  import(/* webpackChunkName: "XterminateGamePage" */ "@/components/Portfolio/XterminateInstance");

export default {
  name: "XterminateGame",
  components: {
    XterminateInstance
  },
  data() {
    return {
      modalOpen: false
    };
  },
  methods: {
    /*
     * @function - setGameModalStatus
     * This function shows or hides modal instance depending on open argument value
     * @param - open (Boolean): If TRUE shows modal, otherwise hides it
     */
    setGameModalStatus(open = false) {
      this.modalOpen = open;
    }
  }
};
</script>

<style lang="scss" scoped>
.xterminate-game {
  &-image {
    @include boxShadow(0.35, true, false);
    border: 0.0625rem solid $main-blue;
    background-color: $white-raw;
    border-radius: 0.45rem;
    display: flex;
    margin: 2rem auto 4rem;
    max-width: 100%;
    max-height: 100%;

    &.black {
      border: 0.125rem solid $main-green;
      background-color: $dark-raw;
    }

    &.scenario {
      @include breakpoint($xlarge) {
        height: auto;
        width: 70%;
      }

      @include breakpoint($xxxlarge) {
        width: 65%;
      }

      @include breakpoint($xxxxlarge) {
        width: 50%;
      }
    }
  }
}
</style>
